/**
 * Plans page script
 * Attaches click handlers for the "Create Free Account" CTA to open auth modal.
 */
import { ensureAuthModalExists, authModal } from '../components/auth-modal';

document.addEventListener('click', (e: Event) => {
  const target = e.target as HTMLElement;
  const btn = target.closest('[data-action="open-auth-modal"]');
  if (btn) {
    e.preventDefault();
    ensureAuthModalExists();
    authModal.show();
  }
});
